import React from 'react';
import WarningIcon from '@mui/icons-material/Warning';

class TranscriptsLedgerDefinitions extends React.Component<{}, {}> {

    constructor(_props: any) {
        super(_props);
    }

    public render() {
        return (
            <div style={{ textAlign: 'left' }}>
                <table border={1} cellSpacing={0} cellPadding={15}>
                    <thead style={{fontWeight: "bold"}}>
                        <tr>
                            <td>
                                <p>Year</p>
                            </td>
                            <td style={{minWidth: 250}}>
                                <p>Return <br /> Filed&nbsp;</p>
                            </td>
                            <td style={{minWidth: 250}}>
                                <p>Filing <br /> Status</p>
                            </td>
                            <td style={{minWidth: 250}}>
                                <p>Assessed <br /> Balance</p>
                            </td>
                            <td style={{minWidth: 250}}>
                                <p>Accrued <br /> Balance</p>
                            </td>
                            <td style={{minWidth: 250}}>
                                <p>Est CSED</p>
                            </td>
                            <td style={{minWidth: 250}}>
                                <p>Est Months Remaining</p>
                            </td>
                            <td style={{minWidth: 250}}>
                                <p>Collections <br /> Active Y/N</p>
                            </td>
                            <td style={{minWidth: 250}}>
                                <p>Lien Filed <br /> Y/N</p>
                            </td>
                        </tr>
                    </thead>
                    <tbody style={{verticalAlign: "top"}}>
                        <tr>
                            <td>
                                <p>the specific tax year (e.g., 2023) the data refers to.</p>
                            </td>
                            <td>
                                <p>Shows whether a tax return exists for this year and <strong>how it was filed</strong>:
                                    <ul>
                                        <li><strong>Original</strong> &ndash; A return was filed by you (or your tax preparer) and processed by the IRS.</li>
                                        <li><strong>SFR (Substitute for Return)</strong> &ndash; The IRS filed a return <em>for you</em> because no return was submitted.</li>
                                    </ul>
                                </p>
                                <p><strong>Important:</strong> An SFR is created using income reported to the IRS (such as W-2s and 1099s) <strong>without deductions, credits, or dependents</strong>, which usually results in a <strong>higher tax bill</strong> than if you had filed yourself.</p>
                                {/* <p><strong>Need to add a warning screen somewhere:&nbsp;</strong></p> */}
                                <p><strong>⚠️ <span style={{color: "#f00"}}>IRS-Filed Return &mdash; Filing Your Own Return May Reduce This Balance. Whether or not you should over-write an original return is a tax and legal question that should be determined by a tax professional.&rdquo;</span></strong></p>
                            </td>
                            <td>
                                <p>How the taxpayer filed (e.g., Single, Married Filing Jointly, Head of Household).</p>
                            </td>
                            <td>
                                <p>The primary tax debt, including original taxes, penalties, and interest already "booked" or formally recorded by the IRS.</p>
                            </td>
                            <td>
                                <p>The total amount currently owed, including <strong>additional</strong> interest and penalties that have built up since the last formal assessment.</p>
                            </td>
                            <td>
                                <p>The Collection Statute Expiration Date (CSED) is an <strong>estimate</strong>, not a guaranteed or fixed date.</p>
                                <p>Certain actions can <strong>pause, extend, or &ldquo;toll&rdquo;</strong> the IRS&rsquo;s time to collect, which may push this date out.</p>
                                <p>Because of this, the actual expiration date can change based on your case history. The date shown is an <strong>estimate</strong> of the Collection Statute Expiration Date (CSED) based on available IRS transcript data. If no CSED date appears, it means there is an <strong>open event currently pausing (tolling) the statute</strong></p>
                            </td>
                            <td>
                                <p>A countdown of how many months are left before the estimated CSED is reached and the debt becomes uncollectible. Certain actions can <strong>pause, extend, or &ldquo;toll&rdquo;</strong> the IRS&rsquo;s time to collect, which may push this date out.</p>
                                <p>Because of this, the actual months remaining can change based on your case history. The months remaining is an <strong>estimate</strong> of the Collection Statute Expiration Date (CSED) based on available IRS transcript data. If no months remaining appears, it means there is an <strong>open event currently pausing (tolling) the statute</strong></p>
                            </td>
                            <td>
                                <p>Shows if the account is currently being pursued by IRS Collections</p>
                            </td>
                            <td>
                                <p>Indicates whether the IRS has filed a <strong>Notice of Federal Tax Lien</strong>, which is a public claim against the taxpayer's property to secure the debt.</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

}

export default TranscriptsLedgerDefinitions;